export default __webpack_public_path__ + "static/media/homeabout1.0bd0bdd5.jpg";